module.exports = __webpack_public_path__ + "static/media/seat-geek.ad2c4600.svg";